export enum ColumnType {
	TEXT = 'textColumn',
	NUMBER = 'numberColumn',
	DATE = 'dateColumn',
	MULTIVALUE = 'multivalueColumn',
}
